import { useQuery } from '@tanstack/react-query';
import { default as productsService } from "@/services/products";
import { 
  IStepInstallationFormData, 
  IStepPersonFormData,
  IStepContractFormData
} from '../../types/stepsFormData';


interface IUseProductsProps {
  power: IStepContractFormData["power"]; 
  selfcons: IStepContractFormData["selfcons"];
  accessTariff: IStepContractFormData["accessTariff"];
  promotionalCode: IStepContractFormData["promotionalCode"];
  cups: IStepInstallationFormData["cups"];
  lang: IStepPersonFormData["commsLanguage"];
}

export const useProducts = ({
  power,
  selfcons,
  accessTariff,
  cups,
  promotionalCode,
  lang
}: IUseProductsProps) => {
  const isReady = 
    power !== null 
    && !!accessTariff
    && cups !== '';

  return useQuery({
    queryKey: ['products', power, selfcons, accessTariff, cups, promotionalCode, lang],
    queryFn: () => productsService.fetchAvailableProducts({
      power,
      selfcons,
      accessTariff,
      cups,
      promotionalCode,
      lang
    }),
    enabled: isReady,
    staleTime: 1000 * 60 * 30 // 5 minutes (cached data remains fresh for this duration)
  })
}

export const useGasProducts = ({
  accessTariff,
  cups,
  lang
}: Pick<IUseProductsProps, "accessTariff" | "cups" | "lang">) => {
  const isReady = !!accessTariff && cups !== '';

  return useQuery({
    queryKey: ['products', accessTariff, cups, lang],
    queryFn: () => productsService.fetchAvailableGasProducts({
      accessTariff,
      cups,
      lang
    }),
    enabled: isReady,
    staleTime: 1000 * 60 * 30 // 5 minutes (cached data remains fresh for this duration)
  })
}